import { Content } from '@orobix/orobix-fe-components'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { withQueryErrorBoundary } from '../../components/QueryErrorBoundary/withQueryErrorBoundary'
import { DatasetsList } from './DatasetsList/DatasetsList'
import { DatasetsListActionsButton } from './DatasetsListActionsButton'

export const DatasetsRoot = withQueryErrorBoundary(() => (
  <Content>
    <PageHeader title="" right={<DatasetsListActionsButton />} />

    <DatasetsList />
  </Content>
))
